<template>
  <div>
    <h1>
      <span v-if="firstName">{{ firstName }}, </span>Thanks for your donation.
    </h1>
  </div>
</template>

<script>
import { getParameterByName } from "../helpers";

export default {
  name: "ThankYouDonation",
  data: function () {
    return {
      firstName: null,
    };
  },
  created: function () {
    let q = getParameterByName("q");
    if (q) {
      let decodeq = "?" + window.atob(q);
      console.log("decodeq", decodeq);
      this.firstName = getParameterByName("firstname", decodeq);

      console.log("firstname", this.firstName);
    }
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// thankYouDonation.vue?2218acc4